import React from 'react'
import styled from 'styled-components'
import {StyleProps} from '../..'
import FocusTrap from '../focus-trap/FocusTrap'
import {VisuallyHidden} from '../text'

export interface IconButtonProps
  extends React.HTMLAttributes<HTMLAnchorElement | HTMLButtonElement> {
  label: string
  href?: string
  disabled?: boolean
  className?: string
  icon: React.ReactElement
  $styles?: StyleProps
}

const IconButtonBase = React.forwardRef<HTMLAnchorElement | HTMLButtonElement, IconButtonProps>(
  ({label, href, onClick, disabled, icon, ...props}, ref) => {
    const elementProps = {
      onClick: !disabled ? onClick : undefined,
      ...props,
    }

    const content = (
      <>
        {icon}
        <VisuallyHidden>{label}</VisuallyHidden>
      </>
    )

    if (href && !disabled) {
      return (
        <a {...elementProps} ref={ref as React.Ref<HTMLAnchorElement>} href={href}>
          {content}
        </a>
      )
    }

    return (
      <button
        {...elementProps}
        ref={ref as React.Ref<HTMLButtonElement>}
        type="button"
        disabled={disabled}
      >
        {content}
      </button>
    )
  },
)

IconButtonBase.displayName = 'IconButtonBase'

const IconButton = styled(IconButtonBase)`
  display: inline-block;
  cursor: pointer;
  border: 0;
  padding: 0;
  background: transparent;

  &:focus {
    ${({theme}) => theme.normalizeStyles({...theme.focus.outlines.withOffset})}
  }

  ${({$styles, theme}) => theme.normalizeStyles($styles)}
`

export default IconButton
